import React, { useEffect } from 'react';
import { Cards } from '@cloudscape-design/components';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Header from '@cloudscape-design/components/header';
import { CustomAppLayout } from '../../layout';
import { useRouter } from '../../router';
import { useStore } from '../../store';
import { mdiNotificationClearAll, mdiBellBadge, mdiBoomGateArrowUp, mdiBell } from '@mdi/js';
import Icon from '@mdi/react';

const pageSize = 20;

export const NotificationsPage = () => {
    const {
        actions: { makeHelpPanelHandler },
    } = useStore();
    const { navigate } = useRouter();



    useEffect(() => {
        //handleRefresh();
    }, []);
    const handleOption = (ref: string) => {
        window.location.href = ref
    }
    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={[
                        { text: 'Inicio', href: '#home' },
                        { text: 'Notificaciones', href: '#transcription-job-list' },
                    ]}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <>

                    <Cards
                        selectionType="single"
                        onSelectionChange={({ detail }) => handleOption(detail.selectedItems[0].id)}
                        cardDefinition={{

                            header: item => item.name
                            ,
                            sections: [
                                {
                                    header: "",
                                    content: item => item.description
                                },
                            ]
                        }}
                        cardsPerRow={[
                            { cards: 1 },
                            { minWidth: 500, cards: 3 }
                        ]}
                        entireCardClickable
                        items={[
                            {
                                id: "#notifications/list",
                                name: (
                                    <span>
                                        <Icon path={mdiNotificationClearAll} size={1.5} />Listado</span>),
                                description: "Detalle de notificaciones enviadas en las últimas 24 horas",
                            },
                            {
                                id: "#notifications/add",
                                name: (
                                    <span>
                                        <Icon path={mdiBellBadge} size={1.5} />Generar</span>),
                                description: "Ingresar una nueva notificación para un usuario",
                            },
                            {
                                id: "#notifications/manual",
                                name: (
                                    <span>
                                        <Icon path={mdiBoomGateArrowUp} size={1.5} />Manual</span>),
                                description: "Realizar una apertura manual por parte del operador",
                            },
                        ]}
                        header={<Header><Icon path={mdiBell} size={2} /> Notificaciones</Header>}
                    />
                </>
            }
        />
    );
};
